<template>
  <div v-if="!onlyShowDate">
    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col-lg-3 lbl">
            <label>Entité:</label>
          </div>
          <div class="col-lg-9">
            <Dropdown
                class="input-width-100"
                v-model="entite"
                :options="entiteLibelles"
                optionValue="valeur"
                optionLabel="texte"
                v-on:keyup.enter="imprimer"
                scrollHeight="700px"
                :showClear="true"
            />
          </div>
        </div>
      </div>
      <div class="col"></div>
    </div>

    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col-lg-3 lbl">
            <label>Genre:</label>
          </div>
          <div class="col-lg-9">
            <Dropdown
                class="input-width-100"
                v-model="genre"
                :options="genresLibelles"
                optionValue="valeur"
                optionLabel="texte"
                @:keyup.enter="imprimer"
                scrollHeight="205px"
                :showClear="true"
            />
          </div>
        </div>
      </div>
      <div class="col"></div>
    </div>

    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col-lg-3 lbl">
            <label>Nature:</label>
          </div>
          <div class="col-lg-9">
            <Dropdown
                class="input-width-100"
                v-model="nature"
                :options="naturesLibelles"
                optionValue="valeur"
                optionLabel="texte"
                @:keyup.enter="imprimer"
                scrollHeight="205px"
                :showClear="true"/>
          </div>
        </div>
      </div>
      <div class="col"></div>
    </div>

    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col-lg-3 lbl">
            <label>Type:</label>
          </div>
          <div class="col-lg-9">
            <Dropdown
                class="input-width-100"
                v-model="type"
                :options="typeLibelles"
                optionValue="valeur"
                optionLabel="texte"
                v-on:keyup.enter="imprimer"
                scrollHeight="700px"
                :showClear="true"
            />
          </div>
        </div>
      </div>
      <div class="col"></div>
    </div>

    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col-lg-3 lbl">
            <label>Catégorie:</label>
          </div>
          <div class="col-lg-9">
            <Dropdown
                class="input-width-100"
                v-model="categorie"
                :options="categorieLibelles"
                optionValue="valeur"
                optionLabel="texte"
                v-on:keyup.enter="imprimer"
                scrollHeight="700px"
                :showClear="true"
            />
          </div>
        </div>
      </div>
      <div class="col"></div>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col-lg-3 lbl">
          <label>Du:</label>
        </div>
        <div class="col-lg-9">
          <CustomInputDate
              class="input-width-100"
              type="date"
              max="9999-12-31"
              v-model="dateDu"
              v-on:keyup.enter="imprimer"
          />
        </div>
      </div>
    </div>
    <div class="col">
      <div class="row">
        <div class="col-lg-3 lbl">
          <label>Au:</label>
        </div>
        <div class="col-lg-9">
          <CustomInputDate
              class="input-width-100"
              type="date"
              max="9999-12-31"
              v-model="dateAu"
              v-on:keyup.enter="imprimer"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import CustomInputDate from '../../Commun/CustomInputDate.vue'

export default {
  name: "CritereRechercheAutoexclusion",
  emits: ['imprimer'],
  components: {
    CustomInputDate
  },
  props: {
    onlyShowDate: {
      type: Boolean,
      default: true
    },
    entiteDefault: {
      type: Number,
      default: null,
    }
  },
  data() {
    return {
      entite: null,
      genre: null,
      nature: null,
      type: null,
      categorie: null,
      dateDu: null,
      dateAu: null,

      entiteLibelles: [],
      genresLibelles: [],
      naturesLibelles: [],
      typeLibelles: [],
      categorieLibelles: [],

      intervenantsLoading: false,

      critereRecherche: {},
    };
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
  methods: {
    assignerListe(entiteDecision) {
      this.entiteLibelles = entiteDecision.entite.libelles;
      this.entite = this.entiteDefault;
      let dateDefaut = new Date();
      this.dateDu = this.$commun.formatDate(dateDefaut.setDate(dateDefaut.getDate() - 7));
      this.dateAu = this.$commun.formatDate(new Date());
    },
    imprimer() {
      this.$emit("imprimer");
    },
    getCriteresRecherche() {
      if (this.dateAu !== null && this.dateAu !== undefined) {
        this.critereRecherche.dateAu = new Date(this.dateAu);
      }
      if (this.dateDu !== null && this.dateDu !== undefined) {
        this.critereRecherche.dateDu = new Date(this.dateDu);
      }
      this.critereRecherche.categorie = this.categorie;
      this.critereRecherche.endroit = this.endroit;
      this.critereRecherche.entite = this.entite;
      this.critereRecherche.fonde = this.fonde;
      this.critereRecherche.genre = this.genre;
      this.critereRecherche.intervenant = this.intervenant;
      this.critereRecherche.localisation = this.localisation;
      this.critereRecherche.nature = this.nature;
      this.critereRecherche.origine = this.origine;
      this.critereRecherche.secteur = this.secteur;
      this.critereRecherche.siteOrigine = this.siteOrigine;
      this.critereRecherche.type = this.type;

      this.critereRecherche.motCle1 = this.motCle1;
      this.critereRecherche.motCle2 = this.motCle2;
      this.critereRecherche.motCle3 = this.motCle3;

      this.critereRecherche.dateCreation = this.dateCreation;
      this.critereRecherche.motDesOperator = this.motDesOperator;

      return this.critereRecherche;
    },
  },
  watch: {
    entite: function (val) {
      if (val !== null && val !== undefined) {
        this.$store.dispatch('dossier/obtenirDecisionLibelleVOsDeCriteresAction', {
          libelleChange: 'Genre',
          nouvelleValeur: val
        })
            .then((res) => {
              this.genresLibelles = res.data;
            });
      } else {
        this.genre = null;
        this.genresLibelles = [];
        this.siteOrigine = null;
        this.sitesLibelles = [];
      }
    },
    genre: function (val) {
      if (val !== null && val !== undefined) {
        this.$store.dispatch('dossier/obtenirDecisionLibelleVOsDeCriteresAction', {
          libelleChange: 'Nature',
          nouvelleValeur: val
        })
            .then((res) => {
              this.naturesLibelles = res.data;
            });
      } else {
        this.nature = null;
        this.naturesLibelles = [];
      }
    },
    nature: function (val) {
      if (val !== null && val !== undefined) {
        this.$store.dispatch('dossier/obtenirDecisionLibelleVOsDeCriteresAction', {
          libelleChange: 'Type',
          nouvelleValeur: val
        })
            .then((res) => {
              this.typeLibelles = res.data;
            });
      } else {
        this.type = null;
        this.typeLibelles = [];
      }
    },
    type: function (val) {
      if (val !== null && val !== undefined) {
        this.$store.dispatch('dossier/obtenirDecisionLibelleVOsDeCriteresAction', {
          libelleChange: 'Categorie',
          nouvelleValeur: val
        })
            .then((res) => {
              this.categorieLibelles = res.data;
            });
      } else {
        this.categorie = null;
        this.categorieLibelles = [];
      }
    },
  }
}
</script>